import CabecalhoPaginaSecundaria, { BotaoVoltar } from "../../../componentes/comuns/CabecalhoPaginaSecundaria";
// =======================
// detalhesEscola.js
// =======================

import React, { useState, useEffect } from "react";
import {
  CssBaseline,
  Container,
  Typography,
  Box,
  Paper,
  Button,
  Tab,
  Alert,
  Select,
  Menu,
  MenuItem,
  IconButton,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import HistoryIcon from "@mui/icons-material/History";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { motion } from "framer-motion";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { useNavigate, useParams } from "react-router-dom";

import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import SchoolIcon from "@mui/icons-material/School";
import EmailIcon from "@mui/icons-material/Email";
import BusinessIcon from "@mui/icons-material/Business";
import ListaAtos from "../../../componentes/ListaAtos";

import { api } from "@api/api";
import { ajustarTamanhoFonteAnalista } from "../../../estilos/global";

const Field = ({ label, value, borderRight = false, sx = {} }) => (
  <Box
    sx={{
      px: 2,
      py: 1.5,
      minWidth: 0,
      borderRight: {
        xs: "none",
        md: borderRight ? "1px solid var(--sear-borda, #e0e0e0)" : "none",
      },
      ...sx,
    }}
  >
    <Typography
      sx={{
        color: "text.secondary",
        fontSize: ajustarTamanhoFonteAnalista("0.75rem"),
        lineHeight: 1.2,
      }}
    >
      {label}
    </Typography>

    <Typography
      sx={{
        color: "text.primary",
        fontSize: ajustarTamanhoFonteAnalista("0.95rem"),
        lineHeight: 1.35,
        mt: 0.5,
        overflowWrap: "anywhere",
      }}
    >
      {value || "Não informado"}
    </Typography>
  </Box>
);

const InfoCard = ({ icon, title, children }) => (
  <Box
    sx={{
      p: 2,
      minWidth: 0,
      height: "100%",
      boxSizing: "border-box",
      border: "1px solid var(--sear-borda, #c9def4)",
      borderRadius: "6px",
      backgroundColor: "var(--sear-superficie, #fff)",
    }}
  >
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        mb: 0.75,
        color: "primary.main",
        "& .MuiSvgIcon-root": {
          fontSize: "1.35rem",
        },
      }}
    >
      {icon}

      <Typography
        sx={{
          color: "primary.main",
          fontSize: ajustarTamanhoFonteAnalista("0.95rem"),
          fontWeight: 600,
          lineHeight: 1.2,
        }}
      >
        {title}
      </Typography>
    </Box>

    {children}
  </Box>
);

const formatCNPJ = (cnpj) => {
  if (!cnpj) return "Não informado";

  const numeros = String(cnpj).replace(/\D/g, "");

  if (numeros.length !== 14) return cnpj;

  return numeros.replace(
    /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
    "$1.$2.$3/$4-$5",
  );
};

const SITUACOES_ESCOLA = [
  {
    valor: "ativa",
    rotulo: "Ativa",
    cor: "var(--sear-sucesso-texto, #159b79)",
    fundo: "var(--sear-sucesso-fundo, #edf8ef)",
    borda: "var(--sear-sucesso-borda, #b7dfbe)",
  },
  {
    valor: "paralisada",
    rotulo: "Paralisada",
    cor: "var(--sear-aviso-texto, #d99800)",
    fundo: "var(--sear-aviso-fundo, #fff8e6)",
    borda: "var(--sear-aviso-borda, #f0d58e)",
  },
  {
    valor: "encerrada",
    rotulo: "Encerrada",
    cor: "var(--sear-erro-texto, #e5474f)",
    fundo: "var(--sear-erro-fundo, #fff1f2)",
    borda: "var(--sear-erro-borda, #f3bdc2)",
  },
  {
    valor: "extinta",
    rotulo: "Extinta",
    cor: "var(--sear-texto-secundario, #7a8591)",
    fundo: "var(--sear-superficie-suave, #f3f4f6)",
    borda: "var(--sear-borda, #d7dde3)",
  },
];

function IndicadorSituacaoEscola({ opcao }) {
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 1.25,
      }}
    >
      <Box
        component="span"
        aria-hidden="true"
        sx={{
          width: 12,
          height: 12,
          borderRadius: "50%",
          flexShrink: 0,
          backgroundColor: opcao.cor,
        }}
      />

      {opcao.rotulo}
    </Box>
  );
}

function SituacaoEscola({ nomeEscola }) {
  const [situacao, setSituacao] = useState("ativa");
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [tipoDialogo, setTipoDialogo] = useState("historico");
  const [dialogoAberto, setDialogoAberto] = useState(false);

  const menuAberto = Boolean(menuAnchor);

  const selecionada = SITUACOES_ESCOLA.find(
    (opcao) => opcao.valor === situacao,
  );

  const abrirDialogo = (tipo) => {
    setMenuAnchor(null);
    setTipoDialogo(tipo);
    setDialogoAberto(true);
  };

  return (
    <Box
      sx={{
        width: { xs: "100%", md: 300 },
        flexShrink: 0,
        p: 1.25,
        border: "1px solid var(--sear-borda, #c9def4)",
        borderRadius: "6px",
        backgroundColor: "var(--sear-superficie, #fff)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
          mb: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <VerifiedUserOutlinedIcon
            sx={{
              color: "primary.main",
              fontSize: 22,
            }}
          />

          <Typography
            id="situacao-escola-label"
            sx={{
              color: "var(--sear-texto, #334155)",
              fontSize: ajustarTamanhoFonteAnalista("0.95rem"),
            }}
          >
            Situação da escola
          </Typography>
        </Box>

        <IconButton
          id="acoes-escola-button"
          size="small"
          aria-label="Opções da escola"
          aria-haspopup="menu"
          aria-controls={menuAberto ? "acoes-escola-menu" : undefined}
          aria-expanded={menuAberto ? "true" : undefined}
          onClick={(event) => setMenuAnchor(event.currentTarget)}
          sx={{
            color: "primary.main",
            borderRadius: "6px",
            backgroundColor: "var(--sear-superficie-azul, #eef6ff)",
          }}
        >
          <MoreVertIcon fontSize="small" />
        </IconButton>
      </Box>

      <Select
        fullWidth
        size="small"
        value={situacao}
        onChange={(event) => setSituacao(event.target.value)}
        inputProps={{
          "aria-labelledby": "situacao-escola-label",
        }}
        IconComponent={KeyboardArrowDownIcon}
        renderValue={() => <IndicadorSituacaoEscola opcao={selecionada} />}
        sx={{
          height: 44,
          borderRadius: "6px",
          fontSize: ajustarTamanhoFonteAnalista("1rem"),
          fontWeight: 600,
          color: "var(--sear-texto, #26334d)",
          backgroundColor: selecionada.fundo,

          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: selecionada.borda,
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              mt: 0.5,
              borderRadius: "8px",
            },
          },
          MenuListProps: {
            "aria-labelledby": "situacao-escola-label",
          },
        }}
      >
        {SITUACOES_ESCOLA.map((opcao) => (
          <MenuItem
            key={opcao.valor}
            value={opcao.valor}
            sx={{
              py: 1.25,
              fontSize: ajustarTamanhoFonteAnalista("0.95rem"),
            }}
          >
            <IndicadorSituacaoEscola opcao={opcao} />
          </MenuItem>
        ))}
      </Select>

      <Menu
        id="acoes-escola-menu"
        anchorEl={menuAnchor}
        open={menuAberto}
        onClose={() => setMenuAnchor(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        MenuListProps={{
          "aria-labelledby": "acoes-escola-button",
        }}
        PaperProps={{
          sx: {
            mt: 0.75,
            minWidth: 240,
            borderRadius: "8px",

            "& .MuiMenuItem-root": {
              gap: 1.25,
              py: 1.25,
              fontSize: ajustarTamanhoFonteAnalista("0.875rem"),
            },
          },
        }}
      >
        <MenuItem onClick={() => abrirDialogo("historico")}>
          <HistoryIcon fontSize="small" sx={{ color: "var(--sear-texto-secundario, #59657a)" }} />
          Ver histórico de alterações
        </MenuItem>

        <Divider />

        <MenuItem
          onClick={() => abrirDialogo("excluir")}
          sx={{ color: "error.main" }}
        >
          <DeleteOutlineIcon fontSize="small" />
          Excluir escola
        </MenuItem>
      </Menu>

      <Dialog
        open={dialogoAberto}
        onClose={() => setDialogoAberto(false)}
        fullWidth
        maxWidth="sm"
        aria-labelledby="dialogo-escola-titulo"
        aria-describedby="dialogo-escola-descricao"
        PaperProps={{
          sx: {
            border: "1px solid var(--sear-borda, #c9def4)",
            borderRadius: "12px",
          },
        }}
      >
        <DialogTitle
          id="dialogo-escola-titulo"
          sx={{
            color: "primary.main",
            fontWeight: 600,
            fontSize: ajustarTamanhoFonteAnalista("1.125rem"),
          }}
        >
          {tipoDialogo === "historico"
            ? "Histórico de alterações"
            : "Excluir escola"}
        </DialogTitle>

        <DialogContent dividers>
          <Typography
            sx={{
              mb: 1.5,
              fontWeight: 600,
              fontSize: ajustarTamanhoFonteAnalista("0.95rem"),
            }}
          >
            {nomeEscola || "Escola"}
          </Typography>

          <Alert
            id="dialogo-escola-descricao"
            severity="info"
            sx={{
              fontSize: ajustarTamanhoFonteAnalista("0.875rem"),
            }}
          >
            {tipoDialogo === "historico"
              ? "A consulta ao histórico ainda não está disponível nesta prévia."
              : "A exclusão ainda não está disponível nesta prévia. Nenhuma escola será excluída."}
          </Alert>
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            variant="outlined"
            onClick={() => setDialogoAberto(false)}
            sx={{ textTransform: "none" }}
          >
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default function InfoEscola() {
  const [tabValue, setTabValue] = useState("1");
  const [escola, setEscola] = useState(null);
  const [retryAttempt, setRetryAttempt] = useState(0);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    async function fetchEscola() {
      setLoading(true);
      setError(null);

      try {
        const response = await fetch(api.schoolDetails(id), {
          credentials: "include",
        });

        if (response.status === 404) {
          setEscola(null);
          return;
        }

        if (!response.ok) {
          throw new Error(`Erro ao buscar escola: ${response.status}`);
        }

        const data = await response.json();
        setEscola(data);
      } catch (error) {
        console.error("Erro ao buscar escola:", error);
        setEscola(null);
        setError("Não foi possível carregar os dados da escola.");
      } finally {
        setLoading(false);
      }
    }

    fetchEscola();
  }, [id, retryAttempt]);

  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  if (loading) {
    return (
      <Container maxWidth={false} disableGutters sx={{ marginTop: 4 }}>
        <Typography variant="h6">Carregando...</Typography>
      </Container>
    );
  }

  // Falha da API ou conexão
  if (error) {
    return (
      <Container maxWidth={false} disableGutters sx={{ pt: 3, pb: 4 }}>
        <Alert
          severity="error"
          variant="outlined"
          action={
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                flexShrink: 0,
              }}
            >
              <Button
                variant="outlined"
                color="error"
                size="small"
                onClick={() => setRetryAttempt((valor) => valor + 1)}
                sx={{
                  fontWeight: 600,
                  textTransform: "none",
                  borderRadius: "6px",
                }}
              >
                Tentar novamente
              </Button>

              <BotaoVoltar onClick={handleBackClick} />
            </Box>
          }
          sx={{
            alignItems: "center",
            "& .MuiAlert-message": {
              flex: 1,
            },
            "& .MuiAlert-action": {
              alignItems: "center",
              pt: 0,
              mr: 0,
            },
          }}
        >
          <Typography sx={{ fontWeight: 600 }}>
            Não foi possível carregar os dados da escola.
          </Typography>

          <Typography variant="body2">
            Verifique sua conexão e tente novamente.
          </Typography>
        </Alert>
      </Container>
    );
  }

  // Escola inexistente
  if (!escola) {
    return (
      <Container maxWidth={false} disableGutters sx={{ py: 4 }}>
        <Alert
          severity="warning"
          variant="outlined"
          action={
            <BotaoVoltar onClick={handleBackClick} />
          }
          sx={{
            alignItems: "center",
            "& .MuiAlert-message": {
              flex: 1,
            },
            "& .MuiAlert-action": {
              alignItems: "center",
              pt: 0,
              mr: 0,
            },
          }}
        >
          <Typography sx={{ fontWeight: 600 }}>
            Escola não encontrada.
          </Typography>

          <Typography variant="body2">
            O registro informado não existe ou não está mais disponível.
          </Typography>
        </Alert>
      </Container>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <CssBaseline />

      <Container maxWidth={false} disableGutters sx={{ py: 4 }}>
        <CabecalhoPaginaSecundaria
            titulo="Perfil Escolar"
            acoes={<SituacaoEscola key={id} nomeEscola={escola.nome} />}
            sx={{ mb: 0.5 }}
            onVoltar={handleBackClick}
          />

        <TabContext value={tabValue}>
          <Box sx={{ display: "flex", alignItems: "flex-end" }}>
            <TabList
              onChange={handleChangeTab}
              aria-label="Abas do perfil escolar"
              sx={{
                minHeight: 44,
                "& .MuiTabs-indicator": {
                  display: "none",
                },
                "& .MuiTabs-flexContainer": {
                  gap: 0.5,
                },
              }}
            >
              <Tab
                label="Informações da Escola"
                value="1"
                sx={{
                  minHeight: 44,
                  minWidth: 0,
                  px: { xs: 1.5, sm: 2 },
                  fontSize: {
                    xs: ajustarTamanhoFonteAnalista("0.85rem"),
                    sm: ajustarTamanhoFonteAnalista("1rem"),
                  },
                  fontWeight: 500,
                  textTransform: "none",
                  border: "1px solid",
                  borderColor: "primary.main",
                  borderBottom: 0,
                  borderRadius: "6px 6px 0 0",
                  color: "text.primary",
                  "&.Mui-selected": {
                    backgroundColor: "var(--sear-acao-azul, #1976d2)",
                    color: "#fff",
                  },
                }}
              />

              <Tab
                label="Atos da Escola"
                value="2"
                sx={{
                  minHeight: 44,
                  minWidth: 0,
                  px: { xs: 1.5, sm: 2 },
                  fontSize: {
                    xs: ajustarTamanhoFonteAnalista("0.85rem"),
                    sm: ajustarTamanhoFonteAnalista("1rem"),
                  },
                  fontWeight: 500,
                  textTransform: "none",
                  border: "1px solid",
                  borderColor: "primary.main",
                  borderBottom: 0,
                  borderRadius: "6px 6px 0 0",
                  color: "text.primary",
                  "&.Mui-selected": {
                    backgroundColor: "var(--sear-acao-azul, #1976d2)",
                    color: "#fff",
                  },
                }}
              />

              <Tab
                label={
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Box component="span">Mantenedoras Vinculadas</Box>

                    <Box
                      component="span"
                      sx={{
                        minWidth: 22,
                        height: 22,
                        px: 0.75,
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "6px",
                        backgroundColor: tabValue === "3" ? "var(--sear-superficie, #fff)" : "var(--sear-superficie-azul, #eaf3fd)",
                        color: "primary.main",
                        fontSize: ajustarTamanhoFonteAnalista("0.95rem"),
                        fontWeight: 700,
                      }}
                    >
                      {escola.mantenedoras?.length || 0}
                    </Box>
                  </Box>
                }
                value="3"
                sx={{
                  minHeight: 44,
                  minWidth: 0,
                  px: { xs: 1.5, sm: 2 },
                  fontSize: {
                    xs: ajustarTamanhoFonteAnalista("0.85rem"),
                    sm: ajustarTamanhoFonteAnalista("1rem"),
                  },
                  fontWeight: 500,
                  textTransform: "none",
                  border: "1px solid",
                  borderColor: "primary.main",
                  borderBottom: 0,
                  borderRadius: "6px 6px 0 0",
                  color: "text.primary",
                  "&.Mui-selected": {
                    backgroundColor: "var(--sear-acao-azul, #1976d2)",
                    color: "#fff",
                  },
                }}
              />
            </TabList>
          </Box>

          <Paper
            elevation={0}
            sx={{
              p: { xs: 1.25, sm: 1.5 },
              border: "1px solid",
              borderColor: "divider",
              borderRadius: "0 8px 8px 8px",
            }}
          >
            <TabPanel value="1" sx={{ p: 0 }}>
              <Box
                sx={{
                  p: 2,
                  mb: 1.5,
                  border: "1px solid var(--sear-borda, #c9def4)",
                  borderRadius: "6px",
                  backgroundColor: "var(--sear-superficie, #fff)",
                }}
              >
                <Typography
                  sx={{
                    color: "primary.main",
                    fontSize: ajustarTamanhoFonteAnalista("0.95rem"),
                    fontWeight: 600,
                    lineHeight: 1.2,
                    mb: 0.5,
                  }}
                >
                  Nome da Escola
                </Typography>

                <Typography
                  sx={{
                    color: "text.primary",
                    fontSize: ajustarTamanhoFonteAnalista("1.1rem"),
                    fontWeight: 500,
                    lineHeight: 1.35,
                  }}
                >
                  {escola.nome || "Não informado"}
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: {
                    xs: "1fr",
                    md: "1.2fr 0.82fr 1fr",
                  },
                  gap: 1.5,
                  alignItems: "stretch",
                }}
              >
                <InfoCard icon={<LocationOnIcon />} title="Endereço">
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns:
                        "minmax(0, 1.4fr) minmax(80px, 0.8fr)",
                    }}
                  >
                    <Field
                      label="Logradouro (Rua/Avenida)"
                      value={escola.rua}
                      sx={{
                        px: 0,
                        py: 1,
                        pr: 1.5,
                        borderRight: "1px solid var(--sear-borda, #d8e3ef)",
                        borderBottom: "1px solid var(--sear-borda, #d8e3ef)",
                      }}
                    />

                    <Field
                      label="Número"
                      value={escola.numero}
                      sx={{
                        px: 0,
                        py: 1,
                        pl: 1.5,
                        borderBottom: "1px solid var(--sear-borda, #d8e3ef)",
                      }}
                    />

                    <Field
                      label="Bairro"
                      value={escola.bairro}
                      sx={{
                        px: 0,
                        py: 1,
                        pr: 1.5,
                        borderRight: "1px solid var(--sear-borda, #d8e3ef)",
                        borderBottom: "1px solid var(--sear-borda, #d8e3ef)",
                      }}
                    />

                    <Field
                      label="CEP"
                      value={escola.cep}
                      sx={{
                        px: 0,
                        py: 1,
                        pl: 1.5,
                        borderBottom: "1px solid var(--sear-borda, #d8e3ef)",
                      }}
                    />
                  </Box>

                  <Field
                    label="Município"
                    value={escola.municipio}
                    sx={{
                      px: 0,
                      pt: 1.25,
                      pb: 0,
                    }}
                  />
                </InfoCard>

                <InfoCard icon={<PhoneIcon />} title="Contatos">
                  <Field
                    label="Telefone"
                    value={escola.contato}
                    sx={{
                      px: 0,
                      py: 1,
                      borderBottom: "1px solid var(--sear-borda, #d8e3ef)",
                    }}
                  />

                  <Field
                    label="E-mail"
                    value={escola.email}
                    sx={{
                      px: 0,
                      pt: 1.25,
                      pb: 0,
                    }}
                  />
                </InfoCard>

                <InfoCard icon={<SchoolIcon />} title="Etapas de ensino">
                  <Typography
                    sx={{
                      color: "text.secondary",
                      fontSize: ajustarTamanhoFonteAnalista("0.75rem"),
                      lineHeight: 1.2,
                      mt: 1,
                    }}
                  >
                    Modalidades de ensino
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 0.75,
                      mt: 0.75,
                    }}
                  >
                    {escola.modalidades && escola.modalidades.length > 0 ? (
                      escola.modalidades.map((modalidade) => (
                        <Box
                          key={modalidade}
                          sx={{
                            px: 1.25,
                            py: 0.4,
                            borderRadius: "999px",
                            backgroundColor: "var(--sear-superficie-azul, #eaf3fd)",
                            color: "var(--sear-azul, #075fc8)",
                            fontSize: ajustarTamanhoFonteAnalista("0.8rem"),
                            fontWeight: 600,
                          }}
                        >
                          {modalidade}
                        </Box>
                      ))
                    ) : (
                      <Typography
                        sx={{
                          color: "text.primary",
                          fontSize: ajustarTamanhoFonteAnalista("0.95rem"),
                        }}
                      >
                        Nenhuma modalidade registrada.
                      </Typography>
                    )}
                  </Box>
                </InfoCard>
              </Box>
            </TabPanel>{" "}
            <TabPanel value="2" sx={{ p: 0 }}>
              <ListaAtos />
            </TabPanel>
            <TabPanel value="3" sx={{ p: 0 }}>
              {escola.mantenedoras?.length > 0 ? (
                <Box sx={{ display: "grid", gap: 1.25 }}>
                  {escola.mantenedoras.map((mantenedora) => (
                    <Box
                      key={mantenedora.id}
                      sx={{
                        display: "grid",
                        gridTemplateColumns: {
                          xs: "1fr",
                          md: "minmax(0, 1.5fr) minmax(130px, 0.7fr) minmax(0, 1fr) auto",
                        },
                        alignItems: "center",
                        gap: { xs: 1.5, md: 2 },
                        p: 1.5,
                        border: "1px solid var(--sear-borda, #c9def4)",
                        borderRadius: "6px",
                        backgroundColor: "var(--sear-superficie, #fff)",
                      }}
                    >
                      {/* Nome e CNPJ */}
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1.25,
                          minWidth: 0,
                        }}
                      >
                        <Box
                          sx={{
                            width: 34,
                            height: 34,
                            borderRadius: "50%",
                            backgroundColor: "var(--sear-superficie-azul, #e7f1fd)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                          }}
                        >
                          <BusinessIcon
                            sx={{
                              color: "primary.main",
                              fontSize: 20,
                            }}
                          />
                        </Box>

                        <Box sx={{ minWidth: 0 }}>
                          <Typography
                            sx={{
                              color: "primary.main",
                              fontSize: ajustarTamanhoFonteAnalista("0.95rem"),
                              fontWeight: 600,
                              lineHeight: 1.2,
                            }}
                          >
                            Nome da Mantenedora
                          </Typography>

                          <Typography
                            sx={{
                              color: "text.primary",
                              fontSize: ajustarTamanhoFonteAnalista("1.1rem"),
                              fontWeight: 500,
                              lineHeight: 1.35,
                              mt: 0.5,
                              overflowWrap: "anywhere",
                            }}
                          >
                            {mantenedora.nome || "Não informado"}
                          </Typography>

                          <Box
                            sx={{
                              display: "inline-flex",
                              mt: 0.5,
                              px: 1,
                              py: 0.25,
                              borderRadius: "999px",
                              backgroundColor: "var(--sear-superficie-azul, #eaf3fd)",
                              color: "var(--sear-azul, #075fc8)",
                              fontSize: ajustarTamanhoFonteAnalista("0.8rem"),
                              fontWeight: 600,
                            }}
                          >
                            CNPJ {formatCNPJ(mantenedora.cnpj)}
                          </Box>
                        </Box>
                      </Box>

                      {/* Cidade */}
                      <Box sx={{ minWidth: 0 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            color: "primary.main",
                          }}
                        >
                          <LocationOnIcon sx={{ fontSize: "1.35rem" }} />

                          <Typography
                            sx={{
                              color: "primary.main",
                              fontSize: ajustarTamanhoFonteAnalista("0.95rem"),
                              fontWeight: 600,
                              lineHeight: 1.2,
                            }}
                          >
                            Cidade
                          </Typography>
                        </Box>

                        <Typography
                          sx={{
                            color: "text.primary",
                            fontSize: ajustarTamanhoFonteAnalista("0.95rem"),
                            fontWeight: 400,
                            lineHeight: 1.35,
                            mt: 0.5,
                          }}
                        >
                          {mantenedora.cidade || "Não informado"}
                        </Typography>
                      </Box>

                      {/* E-mail */}
                      <Box sx={{ minWidth: 0 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            color: "primary.main",
                          }}
                        >
                          <EmailIcon sx={{ fontSize: "1.35rem" }} />

                          <Typography
                            sx={{
                              color: "primary.main",
                              fontSize: ajustarTamanhoFonteAnalista("0.95rem"),
                              fontWeight: 600,
                              lineHeight: 1.2,
                            }}
                          >
                            E-mail
                          </Typography>
                        </Box>

                        <Typography
                          sx={{
                            color: "text.primary",
                            fontSize: ajustarTamanhoFonteAnalista("0.95rem"),
                            fontWeight: 400,
                            lineHeight: 1.35,
                            mt: 0.5,
                            overflowWrap: "anywhere",
                          }}
                        >
                          {mantenedora.email || "Não informado"}
                        </Typography>
                      </Box>

                      <Button
                        variant="contained"
                        size="small"
                        onClick={() =>
                          navigate(`/perfil-mantenedora/${mantenedora.id}`)
                        }
                        sx={{
                          minWidth: 100,
                          fontWeight: 600,
                          textTransform: "none",
                          borderRadius: "6px",
                        }}
                      >
                        Ver perfil
                      </Button>
                    </Box>
                  ))}
                </Box>
              ) : (
                <Typography
                  sx={{
                    color: "text.secondary",
                    fontSize: ajustarTamanhoFonteAnalista("0.95rem"),
                  }}
                >
                  Nenhuma mantenedora vinculada foi encontrada.
                </Typography>
              )}
            </TabPanel>
          </Paper>
        </TabContext>
      </Container>
    </motion.div>
  );
}
